export async function listarDispositivos(){
    const url = `${process.env.REACT_APP_MICROSERVICO_IP}/cmd/devices`;

    try{
        const response = await fetch(url);

        if (!response.ok){
            throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } 
    catch (error) {
        console.error('Erro ao buscar dispositivos:', error);
        throw error;
    }
}

export async function listarDispositivoPorID(idDispositivo){
    const url = `${process.env.REACT_APP_MICROSERVICO_IP}/api/v1/devices/${idDispositivo}`;

    try{
        const response = await fetch(url);

        if (!response.ok){
            throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } 
    catch (error) {
        console.error('Erro ao buscar dispositivo por ID:', error);
        throw error;
    }
}